import React, {Component, useDebugValue, useEffect, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col } from 'react-bootstrap';
import { Container, Row, FormControl, FormLabel, FormCheck } from 'react-bootstrap';
import PosicionDataService from './services/posicion.service.js';
import OrganigramaAreaDataService from './services/organigramaarea.service.js';
import UserDataService from './services/user.serviceaux.js';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import { IoAddCircle } from "react-icons/io5";

function AgregarPosicion(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [posiciones, setposiciones] = useState([]);  
  const [posicionid, setposicionid] = useState(null);  
  const [descripcionposicion, setdescripcionposicion] = useState("");  
  const [juezid, setjuezid] = useState(null);  
  const [users, setUsers] = useState([]);  
  
  const { user } = useSelector(state => state.auth);

  useEffect(() => {
    UserDataService.getAll()
    // asegurarse de que se imprima la lista de usuarios aquí
    .then((resp) => {
      console.log(resp.data);
      setUsers(resp.data);
    })
    .catch((err) => {
      console.error("No se pueden cargar los registros de usuario:" + err);
    })

  },[])

  const onchangeposicion = (e) => {  
    console.log(e.target.value);
    const posicionid = parseInt(e.target.value);
    console.log(posicionid);
    //setarean2id(areasn2.find(obj => obj.id === arean2id) || null);   
    setposicionid(posicionid);
    //setdescripcionarea((areasn2.find(obj => obj.id === arean2id) || {})).nombrearea;
  };

  const onchangejuez = (e) => {  
    console.log(e.target.value);
    const juezid = parseInt(e.target.value);
    console.log(juezid);
    setjuezid(juezid);
  };    
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    console.log(props);
    PosicionDataService.getPosicionByDescr('','id','ASC',props.arean2?props.arean2.id:null)
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);   
        setposiciones(response.data); 
        //setarean2id(response.data[0].id);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    savePosicionOrganigrama();
  } 

  let savePosicionOrganigrama = (e)  =>{ 
    console.log(e.posicionid);
    console.log(posicionid);
    console.log(props);
    let desc = (posiciones.find(obj => obj.id === parseInt(e.posicionid)) || {}).nombreposicion;
    var data = {
      parentid: props.parentid,
      childid: e.posicionid,
      childcategory: 'posicion',
      childdescription: desc,
      userId: e.juezid
    }
    
    console.log(data);

    OrganigramaAreaDataService.create(data)
      .then(response => {
      console.log(response.data);
      setSubmitted(true);
      handleClose();
    })
    .catch(e => {
      console.log(e);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);      
      setSuccmessage('');
      setShowsuccess(false);            
    })  

      
  }


    return (
      <>
        <Button variant="secondary" onClick={handleShow}><IoAddCircle size={15}/></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Agregar posicion'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(savePosicionOrganigrama)}>
              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                  <Form.Label>Nombre área N2</Form.Label>
                  <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean2" id="nombrearean2" disabled defaultValue={props.arean2?props.arean2.nombrearea:null}></FormControl>
                </Col>
              </Row>

              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                    <Controller
                        name="posicionid"
                        control={control}
                        onChange={onchangeposicion}
                        defaultValue={posicionid}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              //onChange={onchangearean2}
                              className="mt-2"
                              type="select"
                              //placeholder="Nombre competencia"
                              isInvalid={errors.posicionid}
                            >
                              <option key={0} value={0}>{"Seleccionar área"}</option>
                              {
                                posiciones.map((row,index) => {
                                  return (
                                    <option key={index} value={row.id}>{row.nombreposicion}</option>
                                  )
                                })
                              }
                            </Form.Select>
                        )}
                    />
                    {errors.arean2id && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere la posición.
                        </Form.Control.Feedback>
                    )}
                </Col>                 
                <Col className='col' md={6}>
                    <Controller
                      name="juezid"
                      control={control}
                      onChange={onchangejuez}
                      //defaultValue={userid}
                      defaultValue={juezid}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Form.Select
                          {...field}
                            className="mt-2"
                            type="text"
                            placeholder="Primer nombre"
                            isInvalid={errors.juezid}
                            //onChange={onchangejuez}
                            //value={username}
                        >
                          <option key={0} value={0}>{"Seleccionar juez"}</option>
                          {
                            users.map((row,index) => {
                              return (
                                <option key={index} value={row.id}>{row.primerapellido + ", " + row.primernombre}</option>
                              )
                            })
                          }                            
                        </Form.Select>
                      )}
                    />
                    {errors.juezid && (
                      <Form.Control.Feedback type="invalid">
                        Se requiere el juez
                      </Form.Control.Feedback>
                    )}
                </Col>  

              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block" >
                  Agregar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default AgregarPosicion;